import {useQuery} from "react-query";
import {useSelector} from "react-redux";
import * as CustomerService from ".././services/customer-service";

export default function useCELinks() {
  const authState = useSelector((state) => state.auth);
  return useQuery("ce-links", () => CustomerService.fetchCELinks(authState.roles), {
    initialData: [],
    initialStale: true,
    keepPreviousData: true,
  });
}
